import type {ISettingsParam, ISettingsSetter} from '@wix/tpa-settings'
import {useSettings as useYoshiSettings} from '@wix/tpa-settings/react'
import {WidgetType, useSettingsBi} from '../../../settings-commons/hooks/use-settings-bi'

export const useSettings = () => {
  const settings = useYoshiSettings()
  const {debouncedEditorEventsWidgetSettingChanged} = useSettingsBi(WidgetType.EventDetails)

  const get = (param: ISettingsParam) => {
    const value = settings.get(param)
    return value
  }

  const getWithFallback = (param: ISettingsParam, fallbackParam: ISettingsParam) => {
    const value = settings.get(param)
    const fallbackValue = settings.get(fallbackParam)
    return value ?? fallbackValue
  }

  const set: ISettingsSetter = (param, value) => {
    debouncedEditorEventsWidgetSettingChanged(param.key, value)
    settings.set(param, value)
  }

  return {
    ...settings,
    get,
    getWithFallback,
    set,
  }
}
